<template>
  <CardPreview :template-html="templateHtml"></CardPreview>
</template>

<script>
import CardPreview from "@/components/cards/CardPreview.vue";

export default {
  metaInfo: {
    title: "You're invited!",
    meta: [
      {
        vmid: "description",
        name: "description",
        content: undefined
      }
    ]
  },

  components: {
    CardPreview
  },

  async fetch({ store, route }) {
    const { card_table_id } = route.params;
    await store.dispatch("fetchFreeInviteHTML", { card_table_id });
  },

  computed: {
    templateHtml() {
      return this.$store.state.freeInviteHTML;
    }
  },

  activated() {
    this.logFirebaseEvent("free_invite_view");
  }
};
</script>
